import { useAsyncData } from '#app'

import { HttpApiError } from '@backmarket/http-api'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTheToast } from '@backmarket/nuxt-module-toast/useTheToast'

import type { GetListingsV2Query, PublicationState } from '~/api/listings/types'
import { PUBLICATION_STATE } from '~/scopes/listings/Listings.constants'

import translations from '../components/ListingsBlock/ListingsBlock.translations'

export function useListings() {
  const $httpFetch = useHttpFetch()
  const { openErrorToast } = useTheToast()
  const i18n = useI18n()

  function getListingsCount() {
    return useAsyncData(
      'shipping-listings-count',
      async () => {
        try {
          const countResponse = await $httpFetch(
            '/api/seller-experience/listings/count',
            {
              query: {
                publicationStates: [
                  PUBLICATION_STATE.ONLINE as PublicationState,
                  PUBLICATION_STATE.OFFLINE as PublicationState,
                  PUBLICATION_STATE.MISSING_PRICE_OR_COMMENT as PublicationState,
                  PUBLICATION_STATE.IN_VALIDATION as PublicationState,
                ],
              } as unknown as GetListingsV2Query,
            },
          )

          return countResponse
        } catch (error) {
          const { detail: content, title } = HttpApiError.fromAnyError(
            error as Error,
          )
          openErrorToast({
            title: title || i18n(translations.errorTitle),
            content: content || i18n(translations.fetchListingsErrorContent),
          })
          throw error
        }
      },
      {
        default: () => ({ count: 0 }),
      },
    )
  }

  return {
    getListingsCount,
  }
}
